<template>
  <v-container>
    <v-row v-if="customer">
      <v-col>
        <v-card class="pa-5">
          <v-card-text>
            <v-list dense disabled>
              <v-list-item-group class="d-flex flex-column justify-center">
                <v-list-item class="my-4" style="border: none;">
                  <v-list-item-icon>
                    <v-avatar color="#def6ff" size="30" class="icon-box">
                      <v-icon small color="#00B3FF">mdi-account</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Customer Name</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{ customer.company_name }}</v-col>
                  </v-row>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>

          <v-row class="px-4 pb-4">
            <v-col cols="12" md="4">
              <v-card class="pa-4 text-center" color="#e3f2fd" elevation="2">
                <v-icon large color="primary">mdi-file-invoice</v-icon>
                <div class="text-h6 font-weight-bold mt-2">{{ currencyCode }}{{ formatNumber(summary.total_invoiced) }}</div>
                <div class="subtitle-2 grey--text text--darken-1">Total Invoiced</div>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-4 text-center" color="#e8f5e9" elevation="2">
                <v-icon large color="success">mdi-cash-check</v-icon>
                <div class="text-h6 font-weight-bold mt-2">{{ currencyCode }}{{ formatNumber(summary.total_paid) }}</div>
                <div class="subtitle-2 grey--text text--darken-1">Total Paid</div>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-4 text-center" :color="outstandingColor" elevation="2">
                <v-icon large :color="outstandingIconColor">mdi-scale-balance</v-icon>
                <div class="text-h6 font-weight-bold mt-2">{{ currencyCode }}{{ formatNumber(summary.outstanding_balance) }}</div>
                <div class="subtitle-2 grey--text text--darken-1">Outstanding Balance</div>
              </v-card>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-btn @click="fetchAccountSummary" color="primary" :loading="loading">Refresh Status</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else-if="!loading">
      <v-col>
        <v-alert type="info">No customer information available.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
import { CustomerService } from "@/services/customer-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "CustomerAccount",
  data() {
    return {
      customer: null,
      summary: {
        total_invoiced: 0,
        total_paid: 0,
        outstanding_balance: 0,
      },
      loading: false,
    };
  },
  computed: {
    ...mapSettingsGetters(["currencyCode"]),
    outstandingColor() {
      if (this.summary.outstanding_balance > 0) return "#fff3e0";
      if (this.summary.outstanding_balance < 0) return "#ffebee";
      return "#e8f5e9";
    },
    outstandingIconColor() {
      if (this.summary.outstanding_balance > 0) return "orange";
      if (this.summary.outstanding_balance < 0) return "red";
      return "green";
    },
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.fetchCustomerInfo();
  },
  methods: {
    formatNumber(value) {
      return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    fetchCustomerInfo() {
      this.loading = true;
      CustomerService.getCustomerInfo(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.customer = response.data.data;
          }
          this.fetchAccountSummary();
        })
        .catch((error) => {
          this.loading = false;
          this.customer = null;
          let data = error.response?.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    fetchAccountSummary() {
      this.loading = true;
      CustomerService.getAccountSummary(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.summary = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.summary = {
            total_invoiced: 0,
            total_paid: 0,
            outstanding_balance: 0,
          };
          let data = error.response?.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
  },
};
</script>

<style scoped>
.detail-label {
  font-weight: bold;
  color: #333;
}
.detail-value {
  font-size: 16px;
}
.icon-box {
  border-radius: 30%;
}
</style>
